module.exports = __webpack_public_path__ + "static/media/vp1.aafeb40f.png";